export default "static/src/images/header-scuola-di-limes-mobile.png";